import styled from 'styled-components';
import TagsList from 'components/TagsList';
import { GREY_300 } from '../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 0.8125rem;
`;

export const SectionHeader = styled.div`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1.25rem;
    color: ${GREY_300};
    text-transform: uppercase;
    margin-bottom: 0.8125rem;
`;

export const StyledTagsList = styled(TagsList)`
    padding: 0.25rem 0;
`;
